import { ButtonBase, makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';
import { ArrowV } from '~svg-components';

const useStyles = makeStyles((theme) => ({
  '@global': {
    '.DayPicker': {
      '&-NavBar': {},

      '&-NavButton': {
        '& svg': { width: 8, fill: theme.colors.grey66 },
        '&:hover': { '& svg': { fill: theme.colors.brandAction } },

        '&--prev': { '& svg': { transform: 'rotate(180deg)' } },
      },
    },
  },
}));

const Navbar = React.forwardRef((props, ref) => {
  const { onPreviousClick, onNextClick, className } = props;
  useStyles();
  return (
    <div className={className} ref={ref}>
      <ButtonBase
        className="DayPicker-NavButton DayPicker-NavButton--prev"
        disableRipple
        onClick={() => {
          onPreviousClick();
        }}
      >
        <ArrowV />
      </ButtonBase>
      <ButtonBase
        className="DayPicker-NavButton DayPicker-NavButton--next"
        disableRipple
        onClick={() => {
          onNextClick();
        }}
      >
        <ArrowV />
      </ButtonBase>
    </div>
  );
});

Navbar.propTypes = {
  onPreviousClick: PropTypes.func.isRequired,
  onNextClick: PropTypes.func.isRequired,
  className: PropTypes.string.isRequired,
};

export default Navbar;
